module.exports = __webpack_public_path__ + "img/chanpin_bg_banner.min.2090e183.jpg";